/**
 * @file キャンセルボタン
 *
 */
'use strict';
import swal from 'sweetalert2';

/**
 * @classname BtnCancelView
 * @classdesc キャンセルボタン
 */
export default class BtnCancelView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('BtnCancelView.constructor');
		this._$e = $e;
		this._cancelUrl = $e.attr('data-cancel-url');
		$e.on('click', () => {this.onClick();});
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnCancelView
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnCancelView.onClick');
		swal({
			title: '確認',
			text: 'この予約を本当に削除してよろしいでしょうか？',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'キャンセルする',
			cancelButtonText: '取りやめる'
		}).then((result) => {
			if (result.value) {
				location.href = this._cancelUrl;
			}
		})
	}
}
